import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

export const CounterContainer = styled(FlexBox)`
    position: absolute;
    width: auto !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    display: flex;
    align-items: flex-end;
    text-align: right;
    color: #909090;
`;

export const TextAreaLengthCounter: FC<{ value: number | string, maxLength?: number, pos: { top?: number, bottom?: number, right?: number, left?: number } }> = ({ value, pos, maxLength = 800 }) => {

    return (
        <CounterContainer style={{...pos, position: 'absolute' }}>{`${value}/${maxLength}`}</CounterContainer>
    )
}import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

export const CounterContainer = styled(FlexBox)`
    position: absolute;
    width: auto !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    display: flex;
    align-items: flex-end;
    text-align: right;
    color: #909090;
`;

export const TextAreaLengthCounter: FC<{ value: number | string, maxLength?: number, pos: { top?: number, bottom?: number, right?: number, left?: number } }> = ({ value, pos, maxLength = 800 }) => {

    return (
        <CounterContainer style={{...pos, position: 'absolute' }}>{`${value}/${maxLength}`}</CounterContainer>
    )
}